import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '@comeon/ui';
import BinaryQuestion from '../../../binary-question.js';
import useTranslations from '../../../translation/use-translations';
import { showNotification } from '../../../notifications/ducks/notifications.js';
import { WE_SPIN_BUY_IN_TEXT_KEYS, WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import { updateDisplayName } from '../ducks/we-spin-duck.js';
import { selectDisplayName } from '../ducks/we-spin-selectors.js';

const TEXT_KEYS = [...WE_SPIN_BUY_IN_TEXT_KEYS, ...WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS];
const inputPattern = '[a-zA-Z][a-zA-Z0-9-_.]{1,20}';

const UpdateDisplayName = ({ onDone, onCancel = onDone }) => {
	const displayName = useSelector(selectDisplayName) || '';
	const [usernameValue, setUsernameValue] = useState(displayName);
	const [valid, setValid] = useState(displayName.length > 0);
	const onChangeHandler = e => {
		setUsernameValue(e.target.value);
		const validity = e.currentTarget.checkValidity();
		setValid(validity);
	};

	const dispatch = useDispatch();

	const { translations: tr, isLoadingTranslations } = useTranslations(TEXT_KEYS);

	const hideUsernameQuestion = useCallback(() => {
		if (!valid) return;
		dispatch(updateDisplayName(usernameValue))
			.then(() => onDone())
			.then(() =>
				dispatch(
					showNotification({
						openInSidebar: true,
						color: 'green',
						autoHide: true,
						message: `${tr.WE_SPIN_BUY_IN_AMOUNT_WELCOME_MSG} ${usernameValue}!`
					})
				)
			)
			.catch(() => {});
	}, [dispatch, valid, tr, usernameValue, onDone]);

	return (
		!isLoadingTranslations && (
			<BinaryQuestion
				shouldOpenBinary
				title={tr.WE_SPIN_BUY_IN_ENTER_USERNAME_TITLE}
				text={tr.WE_SPIN_BUY_IN_CREATE_USERNAME_MSG}
				yesText={tr.WE_SPIN_BUY_IN_CREATE_USERNAME_CONFIRM}
				onYesClick={hideUsernameQuestion}
				noText={tr.WE_SPIN_BUY_IN_CREATE_USERNAME_CANCEL}
				onNoClick={onCancel}
				onOutsideClick={onCancel}
				placeholder={tr.WE_SPIN_BUY_IN_ENTER_USERNAME_PLACEHOLDER}
				inputLabel=""
				inputValue={0} /* using min and inputValue to force binary question valid state */
				min={valid ? 0 : 1} /* binary question should be refactored */
				openInSidebar
			>
				<Input
					autoFocus
					onChange={onChangeHandler}
					value={usernameValue}
					type="text"
					inputRef="binaryInput"
					forceFocus
					pattern={inputPattern}
					validationMessage={valid ? null : tr.WE_SPIN_CHANGE_USERNAME_NAME_VALIDATION_ERROR}
					placeholder={tr.WE_SPIN_BUY_IN_ENTER_USERNAME_PLACEHOLDER}
					label=""
					required
				/>
			</BinaryQuestion>
		)
	);
};

export default UpdateDisplayName;
